import { FC } from "react";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { Box, Flex, Heading } from "@chakra-ui/react";
import Pagination from "../../../components/organism/Pagination/Pagination";
import { PAGE_SIZE_OPTIONS } from "../../../utils/constants";
import { tableStyles } from "../../../utils/styles/tableStyles";

interface RegionSearchTableProps {
  tableConfig: TableConfig;
  paginationConfig: PaginationConfig;
}

const RegionSearchTable: FC<RegionSearchTableProps> = ({
  tableConfig,
  paginationConfig,
}) => {
  const { tableName = "Lista de Itens", dataTable } = tableConfig;

  const {
    pageSize,
    currentPage,
    totalPages,
    handlePageChange,
    renderContent,
    setPageSize,
    totalItems,
  } = paginationConfig;

  return (
    <Flex direction="column" gap="2.5">
      <Flex
        direction="row"
        gap="4"
        justifyContent="space-between"
        alignItems="center"
      >
        <Heading as="h2" size="md" mb="10px">
          {tableName}
        </Heading>
        {dataTable.length > 0 && (
          <Pagination
            totalResults={totalItems ? totalItems : dataTable.length}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            totalPages={totalPages}
            currentPage={currentPage}
            pageSize={pageSize}
            handlePageChange={handlePageChange}
            setPageSize={setPageSize}
          />
        )}
      </Flex>
      <Box width="100%" display="flex" flexDirection="column" sx={tableStyles}>
        {renderContent()}
      </Box>
    </Flex>
  );
};

export default RegionSearchTable;
